import { api } from "../client";

export const getWeeklyUtilization = (params) => {
  const { weekStart, floorName, excludeDepartments, filterZones } = params;

  const queryParams = new URLSearchParams();
  queryParams.append("weekStart", weekStart);

  if (floorName && floorName !== "all") {
    queryParams.append("floorName", floorName);
  }

  if (excludeDepartments && excludeDepartments.length > 0) {
    queryParams.append("excludeDepartments", excludeDepartments.join(","));
  }

  if (filterZones && filterZones.length === 1) {
    queryParams.append("filterZones", filterZones.join(","));
  }

  return api.get(`/api/utilization/weekly?${queryParams}`);
};
